import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';

export const userType: SchemaWithClient<any> = {
  name: 'Role',
  pluralName: 'Role',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/user-types'),
};
